<mat-card appearance="outlined" class="mat-elevation-z1">
  <!-- Loaded View -->
  <ng-container *ngIf="isDataSetLoaded$ | async; else loading">
  <mat-card-title>
    <i class="pad-right"></i><b>{{cardTitle | translate | async }}</b>
    <div class="pull-right">
      <button mat-button title="Options" class="card-options-button" [matMenuTriggerFor]="helpOptions"><i class="fa fa-ellipsis-v fa-primary" style="font-size: 1.4em;"></i></button>
      <mat-menu #helpOptions="matMenu">
        <button mat-menu-item style="outline: none;" (click)="openHelpTextClicked()">{{ "Help" | translate : locale | async}}</button>
      </mat-menu>
    </div>
  </mat-card-title>
  <mat-card-content class="card-block target-card">
    <table>
      <tbody>
        <tr>
          <td>
            <div style="position: absolute; width: 99%; z-index: 0" [chart]="currentChart"></div>
            <span class="focus-metric-value">
              <b>{{primaryMetricValue}}</b>
              <i [ngClass]="[primaryMetricTrendArrow,primaryMetricTrendColor]"
                                        style="font-size: .9em;" class="pad-left"></i>
            </span>
            <br />
            <span class="focus-metric-label">{{primaryMetricName | translate : locale | async }}</span>
          </td>
        </tr>
      </tbody>
  </table>
  </mat-card-content>
  <mat-card-footer>
    <table>
      <tbody>
        <tr>
          <td *ngIf="!!leftMetricName">
            <span class="secondary-metric-value">
              <b>{{leftMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[leftMetricTrendArrow,leftMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{leftMetricName | translate : locale | async }}
            </span>
          </td>
          <td *ngIf="!!centerMetricName">
            <span class="secondary-metric-value">
              <b>{{centerMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[centerMetricTrendArrow, centerMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{centerMetricName | translate : locale | async }}
            </span>
          </td>
          <td *ngIf="!!rightMetricName">
            <span class="secondary-metric-value">
              <b>{{rightMetricValue}}</b>
              <span class="footer-chevron"><i [ngClass]="[rightMetricTrendArrow, rightMetricTrendColor]"></i></span>
            </span>
            <br />
            <span class="secondary-metric-label">
              {{rightMetricName | translate : locale | async }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-footer>
</ng-container>

  <!-- Loading View with Pulse Animations -->
  <ng-template #loading>
    <div class="flex flex-col gap-6 pt-4 px-3 pb-3 overflow-hidden @container" syncPulse>
      <div class="h-5 w-36 ml-3 bg-gray-100 rounded mb-[20px]"></div>
      <div class="flex flex-col items-center gap-3 mb-[17px]">
        <div class="flex items-center justify-center gap-3">
          <div class="h-16 w-32 bg-gray-100 rounded"></div>
          <div class="h-16 w-16 bg-gray-100 rounded-full"></div>
        </div>
        <div class="h-8 w-40 bg-gray-100 rounded"></div>
      </div>
      <div class="flex items-center justify-between gap-1 @sm:gap-6">
        @for(_ of [0,1,2]; track $index) {
          <div class="flex flex-1 flex-col items-center gap-2">
            <div class="h-7 w-16 @md:w-20 bg-gray-100 rounded"></div>
            <div class="h-4 w-20 @md:w-28 bg-gray-100 rounded"></div>
          </div>
        }
      </div>
    </div>
  </ng-template>
</mat-card>
